import React from 'react'

export const FeedbackIcon = ({ rating, setRating }) => {
    const handleStarClick = (star) => {
      setRating(star);
    };
  return (
    <>
    {[1, 2, 3, 4, 5].map((star) => (
        <span
            key={star}
            className={`pt-cursor text-warning ${star <= rating ? 'icon-star-fill' : 'icon-star'}`}
            onClick={() => handleStarClick(star)}
        ></span>
    ))}
    </>
  )
}

export default FeedbackIcon